module.exports = __webpack_public_path__ + "img/0.d920c24b.jpg";